module.exports = __webpack_public_path__ + "img/13.019d87ce.webp";